import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaClock, FaArrowRight } from 'react-icons/fa';
import logo from './wysupp-icon-green-transparent.svg';

export default function SessionExpired() {
    const navigate = useNavigate();

    const handleLoginRedirect = () => {
        navigate('/'); // Or '/' if that is your login route
    };

    return (
        <div className="session-page-container">
            <div className="session-card">
                <div className="icon-wrapper">
                    <FaClock className="timeout-icon" />
                </div>
                
                <h1 className="session-title">Session Expired</h1>
                
                <p className="session-message">
                    For your security, your session has timed out due to inactivity. 
                    Please log in again to continue working.
                </p>

                <div className="project-context-label">
                    <span className="logo-text">Wysupp Validate</span>
                </div>

                <button onClick={handleLoginRedirect} className="action-button primary">
                    Return to Login <FaArrowRight />
                </button>
            </div>

            <style>{`
                :root {
                    --dark-bg: #1a202c; 
                    --card-bg: #2d3748; 
                    --text-color: #e2e8f0; 
                    --light-text: #a0aec0;
                    --green-accent: #48bb78; 
                    --green-hover: #38a169;
                    --border-color: #4a5568;
                }

                .session-page-container {
                    background-color: var(--dark-bg);
                    min-height: 100vh;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-family: 'Inter', sans-serif;
                    padding: 1rem;
                }

                .session-card {
                    background-color: var(--card-bg);
                    border: 1px solid var(--border-color);
                    border-radius: 12px;
                    padding: 3rem 2.5rem;
                    max-width: 450px;
                    width: 100%;
                    text-align: center;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .icon-wrapper {
                    background-color: rgba(72, 187, 120, 0.1);
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 1.5rem;
                    border: 1px solid rgba(72, 187, 120, 0.2);
                }

                .timeout-icon {
                    font-size: 2.5rem;
                    color: var(--green-accent);
                }

                .session-title {
                    font-size: 1.75rem;
                    font-weight: 700;
                    color: var(--text-color);
                    margin: 0 0 1rem 0;
                }

                .session-message {
                    color: var(--light-text);
                    font-size: 1rem;
                    line-height: 1.6;
                    margin-bottom: 2rem;
                }

                .project-context-label {
                    margin-bottom: 2rem;
                    opacity: 0.8;
                }
                
                .logo-text {
                    font-weight: 600;
                    color: var(--green-accent);
                    letter-spacing: 0.5px;
                }

                .action-button {
                    background-color: var(--green-accent);
                    color: #1a202c; /* Dark text on green button for contrast */
                    border: none;
                    border-radius: 8px;
                    padding: 0.8rem 1.5rem;
                    font-size: 1rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                    width: 100%;
                    justify-content: center;
                }

                .action-button:hover {
                    background-color: var(--green-hover);
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
                }
            `}</style>
        </div>
    );
}